import { render, staticRenderFns } from "./UserAccount.component.vue?vue&type=template&id=e2003262&scoped=true"
import script from "./UserAccount.component.vue?vue&type=script&lang=ts"
export * from "./UserAccount.component.vue?vue&type=script&lang=ts"
import style0 from "./UserAccount.component.vue?vue&type=style&index=0&id=e2003262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2003262",
  null
  
)

export default component.exports